import PageHero from '../components/PageHero';
import ServiceCard from '../components/ServiceCard';
import { services } from '../data/services';

function Services() {
  return (
    <>
      <PageHero
        eyebrow="Eight connected disciplines"
        title={<>Everything your story needs.</>}
        text="From the lens to the launch, our multidisciplinary team delivers polished media experiences under one roof."
      />
      <section className="all-services">
        <div className="service-grid">
          {services.map((service, index) => <ServiceCard key={service.slug} service={service} index={index} />)}
        </div>
      </section>
    </>
  );
}

export default Services;